import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import VideoModal from 'components/modals/VideoModal';
import LeftMenu from './components/LeftMenu';

const CanITrustIyiMakina = ({ t }) => {
  const [videoUrl, setVideoUrl] = useState('');

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('aboutUs'),
      url: '/about-us/about-us',
    },
    {
      label: 'iyiMakina.com Hakkında',
      url: '/about-us/can-i-trust-iyimakina',
    },
  ];

  return (
    <>
      <main className="has-header">
        <div className="container">
          <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
            <div className="col">
              <Breadcrumb links={breadcrumbs} />
            </div>
          </div>
          <div className="row">
            <LeftMenu currentPage="can-i-trust-iyimakina" />
            <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
              <div className="row mb-20">
                <div className="col">
                  <h1 className="h1">iyiMakina.com’a Güvenebilir miyim?</h1>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col-15">
                  <p>
                    iyimakina.com, makina alım-satım işlemlerinizi şeffaf ve güvenilir bir şekilde gerçekleştirmenizi sağlayan online açık artırma platformudur.
                    Her bir süreç, kullanıcılarımızın makina alım satım işlemlerini sorunsuz gerçekleştirmeleri için profesyonel ekibimiz tarafından alıcı ve satıcıya eşit mesafede ve yasal çerçevede titizlikle yürütülür.
                    45 yıllık sektör tecrübesiyle en iyi bildiği işi yapan iyiMakina.com; şeffaf, kolay ve hızlı sistemi ile ikinci el iş makinası almak veya satmak isteyenler için en güvenilir adrestir.
                  </p>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col-15">
                  <h2 className="h5">Tekerleği Tekmelemenize Gerek Kalmayan Makinalar</h2>
                </div>
                <div className="col-15">
                  <p>
                    Sitemizde yer alan tüm makinalar, uzman ekspertizler tarafından yürütülen hummalı çalışmalar ile incelenir ve tüm detaylarıyla kullanıcılarımıza sunulur.
                    Ayrıca uzman ekibimiz tarafından makinaların detaylı incelemesi yapılır ve makinaya ait yüzün üzerinde fotoğraf ve videoyu alıcıların incelemesi için sitede sunulur.
                  </p>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col-15">
                  <h2 className="h5">Manipülasyondan Uzak ve Şeffaf Sistem</h2>
                </div>
                <div className="col-15">
                  <p>
                    “Alıcılar”, açık artırmaya katılarak bir makinaya teklif vermek ya da “Hemen Al” seçeneğiyle makinayı doğrudan satın almak için “Teminat Bedeli” öderler.
                    Tahsil edilen teminat bedeli, yalnızca alım-satım işleminin gerçekleştiği ve ödemenin yapıldığı durumlarda alıcıya iade edilir.
                    Teminat bedeli sayesinde sadece ciddi alıcıların açık artırmaya katılması sağlanır. Bu sayede müzayedeler manipülasyona uğramadan gerçekleşir.
                  </p>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col-15">
                  <h2 className="h5">Adil Piyasa Değerinde Satış</h2>
                </div>
                <div className="col-15">
                  <p>
                    İş makinasını doğru fiyatlandırılmasının hem alıcılar hem de satıcılar için hassas bir konu olduğunun farkındayız.
                    Alıcılar kimi zaman makina için adil piyasa değerinden daha aşağı vermek isteyebilirlerken satıcılar da fahiş fiyatlar isteyebilirler.
                    iyiMakina hem alıcının hem satıcının hakkını korumak için iş makinalarını açık artırma yöntemiyle satışa çıkartır böylece anlık olarak serbest piyasa ortamı oluşturulur ve makinanın satış fiyatı organik olarak adil piyasa değerine çıkar.
                  </p>
                  <p>
                    Satıcılar doğal olarak makinalarının açık artırma esnasında düşük bir fiyattan satılabileceğinden endişelenebilirler.
                    iyiMakina.com bunun önüne geçmek için satıcıların makinalarını satmak isteyebilecekleri en düşük makul fiyatı (Rezerv Fiyat) belirlerlenmesine yardımcı olur ve eğer makina açık artırma sırasında  belirlenen fiyatı geçemezse satış gerçekleşmez.
                  </p>
                  <p>
                    Satış yöntemleriyle ilgili daha fazla bilgi almak isterseniz
                    {' '}
                    <Link href="/content/selling/auction-process">
                      <a>buraya</a>
                    </Link>
                    {' '}
                    tıklayabilirsiniz.
                  </p>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col-15 mb-3 d-flex justify-content-center">
                  <h2 className="h2">Destekçilerimiz</h2>
                </div>
                <div className="separator separator--horizontal separator--opacity-1 mb-4" />
                <div className="col-15 mb-3">
                  <div className="d-flex justify-content-center">
                    <Image
                      src="/image/supporters/borsa-istanbul-ozel-pazar.png"
                      width="210"
                      height="210"
                    />
                  </div>
                  <p className="mt-4">
                    Özel Pazar; halka açılmadan pay alımı-satımı yapmak amacıyla şirketler ile yatırımcıları bir araya getiren web tabanlı ve üyelik bazlı bir platformdur.
                    Özel Pazar, şirketlere halka açılmadan finansman bulma, ortak olduğu şirketteki payını satmak isteyen şirket ortaklarına likide sağlama, yatırımcılara ise yaptıkları yatırımları likidite edebilecek alıcıları bulma olanağı sağlar.
                    iyiMakina, 2021 yılında Borsa İstanbul Özel Pazarı’na üye kabul edilen 7 girişimden biridir.
                  </p>
                </div>
                <div className="separator separator--horizontal separator--opacity-1 mb-4" />
                <div className="col-15 mb-3">
                  <div className="d-flex justify-content-center">
                    <Image
                      src="/image/supporters/ostim.png"
                      width="500"
                      height="160"
                    />
                  </div>
                  <div className="mt-4">
                    <p>
                      Ankara’nın öncü sanayi bölgelerinden biri olarak yarım asrı geride bırakan OSTİM, 17 sektör ve 139 işkolunda, 6.200’den fazla işletme, 60.000’den fazla çalışanın faaliyet gösterdiği, milli ihtiyaçların karşılanmasında bir çözüm merkezi olarak uluslararası marka değerine sahip bir KOBİ kentidir.
                    </p>
                    <p>
                      Yeni Fikirler Yeni İşler erken aşama hızlandırma programının başından beri destekçisi olan OSTİM; ODTÜ ve ODTÜ TEKNOKENT tarafından 16’ıncısı düzenlenen Yeni Fikirler Yeni İşler’de OSTİM Özel Ödülünü iyiMakinaya layık gördü.
                    </p>
                    <p>
                      OSTİM Yönetim Kurulu Başkanı Orhan Aydın, “OSTİM ekosistemine uygun, OSTİM ekosistemini tamamlayan ve OSTİM içerisindeki kümelerimizle birlikte değer üretebilecek; gelecekte de desteğimizi devam ettireceğimiz projelerden biri olan iyiMakina.com, OSTİM özel ödülüne layık görülmüştür.” dedi.
                    </p>
                  </div>
                  <div className="col-15">
                    <div className="row mb-20">
                      <div className="media-container media-container--no-radius" style={{ backgroundImage: 'url(/temp/ostim-video-thumbnail.jpg' }}>
                        <div className="video-overlay video-overlay--bg-gray">
                          <a
                            className="im-button im-button--mobile-fluid im-button--mobile-center"
                            onClick={() => setVideoUrl('https://www.youtube.com/embed/KFvTcJuOFdY?autoplay=1&amp;autohide=1&amp;fs=1&amp;start=83&end=127&amp;rel=0&amp;hd=1&amp;wmode=transparent&amp;enablejsapi=1&amp;html5=1')}
                          >
                            <svg>
                              <use xlinkHref="/image/icons.svg#ic-play-yellow" />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="separator separator--horizontal separator--opacity-1 mb-4" />
                <div className="col-15 mb-3">
                  <div className="d-flex justify-content-center">
                    <Image
                      src="/image/supporters/itu-ari-teknokent.png"
                      width="530"
                      height="140"
                    />
                  </div>
                  <p className="mt-4">
                    İTÜ ARI Teknokent, teknoloji firmalarına ve girişimcilere teknoloji geliştirmeleri ve bu teknolojileri ticarileştirmeleri için en uygun ortam ve olanakları sunarak Türkiye’nin teknoloji gelişimine katkı sağlamayı hedefleyen Teknoloji Geliştirme Bölgesi Yönetici Şirketi'dir.
                    iyiMakina İTÜ ARI Teknokent markalarından biri olan; İleri Aşama Girişimcilik Merkezi İTÜ Magnet içerisinde yer almaktadır.
                  </p>
                </div>
                <div className="separator separator--horizontal separator--opacity-1 mb-4" />
                <div className="col-15 mb-3">
                  <div className="d-flex justify-content-center">
                    <Image
                      src="/image/supporters/tubitak.png"
                      width="190"
                      height="190"
                    />
                  </div>
                  <div className="mt-4">
                    <p>
                      TÜBİTAK, 1512 Girişimcilik Destek Programı (BİGG)
                    </p>
                    <p>
                      TÜBİTAK, BİGG; girişimcilerin, teknoloji ve yenilik odaklı iş fikirlerini, katma değer ve nitelikli istihdam yaratma potansiyeli yüksek teşebbüslere dönüştürebilmeleri için, fikir aşamasından pazara kadar olan faaliyetlerin desteklenmesi, böylece nitelikli girişimciliğin özendirilmesi ve uluslararası rekabet gücü olan, yenilikçi, teknoloji düzeyi yüksek ürün ve hizmetleri geliştirebilen başlangıç firmaları oluşturmasını amaçlayan destek programıdır.
                      iyiMakina TÜBİTAK, 1512 Girişimcilik Destek Programı kapsamında destek almıştır.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <VideoModal
        videoUrl={videoUrl}
        setVideoUrl={setVideoUrl}
      />
    </>
  );
};

CanITrustIyiMakina.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async ({ req }) => {
  const { t } = req;

  return {
    props: {
      blackHeader: true,
      headTitle: t('canITrustIyiMakina'),
    },
  };
};

CanITrustIyiMakina.Layout = Layout;

export default withTranslation('common')(CanITrustIyiMakina);
